import { render, staticRenderFns } from "./wheel.vue?vue&type=template&id=b0564d62&scoped=true&"
import script from "./wheel.vue?vue&type=script&lang=js&"
export * from "./wheel.vue?vue&type=script&lang=js&"
import style0 from "./wheel.vue?vue&type=style&index=0&id=b0564d62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0564d62",
  null
  
)

export default component.exports